export default {
    methods: {

        getUserfailedMsg: function () {
            return this.getsessionStorageItem('_khonsu_user_login_failed_msg');
        },
        setUserfailedMsg: function (value) {
            this.setsessionStorageItem('_khonsu_user_login_failed_msg', value);
        },
        setUserResetFailedMsg: function (value) {
            this.setsessionStorageItem('_khonsu_user_reset_failed_msg', value);
        },
        setUserActivationFailedMsg: function (value) {
            this.setsessionStorageItem('_khonsu_user_Activation_failed_msg', value);
        },
        setUserActivationSuccessMsg: function (value) {
            this.setsessionStorageItem('_khonsu_user_Activation_success_msg', value);
        },
        setUserforgetPasswordFailedMsg: function (value) {
            this.setsessionStorageItem('_khonsu_user_forgetPassword_failed_msg', value);
        },
        getUserLoginErrorStatus: function () {
            return this.getsessionStorageItem('_khonsu_user_login_error_status');
        },
        getUserResetErrorStatus: function () {
            return this.getsessionStorageItem('_khonsu_user_reset_error_status');
        },
        setUserLoginErrorStatus: function (value) {
            this.setsessionStorageItem('_khonsu_user_login_error_status', value);
        },
        setUserResetErrorStatus: function (value) {
            this.setsessionStorageItem('_khonsu_user_reset_error_status', value);
        },
        getUserLoginStatus: function () {
            return this.getsessionStorageItem('_khonsu_user_login_status');
        },

        getUserName: function () {
            return this.getsessionStorageItem('_khonsu_user_name');
        },
        setUserName: function (value) {
            this.setsessionStorageItem('_khonsu_user_name', value);
        },
        setUserEmail: function (value) {
            this.setsessionStorageItem('_khonsu_user_email', value);
        },
        setUserLoginStatus: function (value) {
            return this.setsessionStorageItem('_khonsu_user_login_status', value);

        },

        setUserPlanStatus: function (value) {
            return this.setsessionStorageItem('_khonsu_user_plan_status', value);

        },
        setUserPlanName: function (value) {
            return this.setsessionStorageItem('_khonsu_user_plan_name', value);

        },
        setUserPlanSearchCount: function (value) {
            return this.setsessionStorageItem('_khonsu_user_plan_search_count', value);

        },
        setUserPlanExpiry_date: function (value) {
            return this.setsessionStorageItem('_khonsu_user_plan_expiry_date', value);

        },





        getUserToken: function () {
            return this.getsessionStorageItem('_khonsu_app_token');
        },
        setUserAccessToken: function (access_token) {
            this.setsessionStorageItem('_khonsu_app_token', access_token);

        },


        getsessionStorageItem: function (key) {
            return sessionStorage.getItem(key);
        },
        setsessionStorageItem: function (key, value) {
            sessionStorage.setItem(key, value);
        },
        removesessionStorageItem: function (key) {
            sessionStorage.removeItem(key);
        }

    }
}